import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'powerOfAttorneyName',
    label: 'POA Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'powerOfAttorneyDesignation',
    label: 'POA Designation',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'powerOfAttorneyVerbiage',
    label: 'POA Verbiage',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'powerOfAttorneyEmail',
    label: 'POA Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'powerOfAttorneyPhone',
    label: 'POA Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const poaForm = {
  name: FormNames.POA,
  label: 'POA',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
